import { render, staticRenderFns } from "./select-box.vue?vue&type=template&id=2caa1f54&scoped=true"
import script from "./select-box.vue?vue&type=script&lang=js"
export * from "./select-box.vue?vue&type=script&lang=js"
import style0 from "./select-box.vue?vue&type=style&index=0&id=2caa1f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa1f54",
  null
  
)

export default component.exports